import { render } from "./ActionsMessageHeaderNew.vue?vue&type=template&id=0841c92e&scoped=true"
import script from "./ActionsMessageHeaderNew.vue?vue&type=script&lang=js"
export * from "./ActionsMessageHeaderNew.vue?vue&type=script&lang=js"

import "./ActionsMessageHeaderNew.vue?vue&type=style&index=0&id=0841c92e&lang=scss&scoped=true"
import "./ActionsMessageHeaderNew.vue?vue&type=style&index=1&id=0841c92e&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0841c92e"]])

export default __exports__